import { SiteWideDemoFormFieldValues } from '@components/SiteWideDemoForm/siteWideDemoFormHelpers';
import { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } from './sessionStorageService';
export const demoFormDataKey = 'siteWideDemoFormData';

export function updateSiteWideDemoFormData(newFormData: SiteWideDemoFormFieldValues): void {
    let formStorage = getSiteWideDemoFormData();

    if (formStorage) {
        formStorage = { ...formStorage, ...newFormData };
    } else {
        formStorage = newFormData;
    }

    setSiteWideDemoFormData(formStorage);
}

export function getSiteWideDemoFormData(): SiteWideDemoFormFieldValues {
    const formData = getSessionStorageItem(demoFormDataKey);

    return formData ? JSON.parse(formData) : null;
}

export function setSiteWideDemoFormData(newFormData: SiteWideDemoFormFieldValues): void {
    setSessionStorageItem(demoFormDataKey, JSON.stringify(newFormData));
}

export function clearSiteWideDemoFormData(): void {
    removeSessionStorageItem(demoFormDataKey);
}
